import React from "react";
import {
  Workspaces,
  AccessTime,
  Payments,
  TransferWithinAStation,
  Groups,
  ModeStandby,
  DateRange,
  LocationOn,
  AccessibilityNew,
  TripOrigin,
  EnergySavingsLeaf,
  AirlineSeatIndividualSuite,
  NoAccounts,
  PermIdentity,
  Rule,
  Logout,
  AssignmentLate,
  HourglassBottom,
  MilitaryTech,
  BlurOn,
  QueryBuilder,
  Forward5,
  Alarm,
  Forward10,
  Timelapse,
  SettingsBackupRestore,
  LockClock,
  FilterTiltShift,
  Watch,
  ScheduleSend,
  Schedule,
  People,
  Badge,
  Boy,
  Girl,
  Functions,
  PersonRemove,
  WorkHistory,
  JoinFull,
} from "@mui/icons-material";
import {
  Business,
  Person,
  EventAvailable,
  BeachAccess,
  Weekend,
  Work,
  CheckCircle,
  Cancel,
  ErrorOutline,
  LockOpen,
  DirectionsRun,
  FreeBreakfast,
  ExitToApp,
  TrendingUp,
  AcUnit,
} from "@mui/icons-material";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import EventNoteIcon from "@mui/icons-material/EventNote";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import {
  CheckCircleOutline,
  Foundation,
  Policy,
  WorkspacesOutlined,
} from "@mui/icons-material";

export const departmentWiseHeader = [
  {
    name: "Date",
    key: "date",
  },
  {
    name: "Department",
    key: "department_name",
  },
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Total Assigned",
    key: "total_assigned",
  },
  {
    name: "Present",
    key: "present",
  },
  {
    name: "Missing",
    key: "missing",
  },
  {
    name: "Leave",
    key: "leave",
  },
  {
    name: "Absent",
    key: "absent",
  },
  {
    name: "Over Time",
    key: "overtime",
  },
  {
    name: "Early Exit",
    key: "early_exit",
  },
  {
    name: "Late Entry",
    key: "late_entry",
  },
];

export const departmentExpandHeader = [
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Total Assigned",
    key: "assigned_count",
  },
  {
    name: "Present",
    key: "present_count",
  },
  {
    name: "Missing",
    key: "missing_count",
  },
  {
    name: "Leave",
    key: "leave_count",
  },
  {
    name: "Absent",
    key: "absent_count",
  },
  {
    name: "Over Time",
    key: "overtime_count",
  },
  {
    name: "Early Exit",
    key: "early_exit_count",
  },
  {
    name: "Late Entry",
    key: "late_entry_count",
  },
];

export const shiftCategoryWise = [
  {
    name: "Date",
    key: "date",
  },
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Department",
    key: "department_name",
  },

  {
    name: "Total Assigned",
    key: "total_assigned",
  },
  {
    name: "Present",
    key: "present",
  },
  {
    name: "Missing",
    key: "missing",
  },
  {
    name: "Leave",
    key: "leave",
  },
  {
    name: "Absent",
    key: "absent",
  },
  {
    name: "Over Time",
    key: "overtime",
  },
  {
    name: "Early Exit",
    key: "early_exit",
  },
  {
    name: "Late Entry",
    key: "late_entry",
  },
];

export const shiftWiseExpandDetails = [
  {
    name: "Department Name",
    key: "department_name",
  },
  {
    name: "Total Assigned",
    key: "assigned_count",
  },
  {
    name: "Present",
    key: "present_count",
  },
  {
    name: "Missing",
    key: "missing_count",
  },
  {
    name: "Leave",
    key: "leave_count",
  },
  {
    name: "Absent",
    key: "absent_count",
  },
  {
    name: "Over Time",
    key: "overtime_count",
  },
  {
    name: "Early Exit",
    key: "early_exit_count",
  },
  {
    name: "Late Entry",
    key: "late_entry_count",
  },
];

//Leave Summary
export const leaveSummaryListView = [
  {
    name: "Name",
    key: "user_name",
  },
  {
    key: "employee_id",
    name: "Employee ID",
  },
  {
    name: "Department",
    key: "department",
  },
  {
    name: "Annual Allowance",
    key: "annual_allowance",
  },
  {
    name: "Total Credited",
    key: "credited_leave",
  },
  {
    name: "Planned",
    key: "planned_leave",
  },
  {
    name: "Used",
    key: "used_leave",
  },
  {
    name: "Expired",
    key: "expired_leave",
  },
  {
    name: "Balance",
    key: "available_leave",
  },
  {
    name: "Permissions",
    key: "permission_count",
  },
  {
    name: "Action",
    key: "",
  },
];
//Attendance List view Headers

export const attendanceHeaderList = [
  {
    name: "",
    key: "",
  },
  {
    name: "Name",
    key: "user_name",
  },
  {
    name: "Shift",
    key: "shift_name",
  },
  {
    name: "Check-In",
    key: "check_in_time_formatted",
  },
  {
    name: "Check-Out",
    key: "check_out_time_formatted",
  },
  {
    name: "Breaks",
    key: "planned_leave",
  },
  {
    name: "Shift Hours",
    key: "used_leave",
  },
  {
    name: "Over Time Hours",
    key: "expired_leave",
  },
  {
    name: "Unit",
    key: "available_leave",
  },
  {
    name: "Total Working hours",
    key: "permission_count",
  },
  {
    name: "Leave Credit Hours",
    key: "",
  },
  {
    name: "Status",
    key: "",
  },
];

export const entryMethod = [
  {
    label: "IN",
  },
  {
    label: "OUT",
  },
];

export const lateReportHeader = [
  {
    key: "username",
    name: "Employee Name",
    type: "string",
    icon: <AcUnit fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee Id",
    type: "string",
    icon: <AccessibilityNew fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <TripOrigin fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "department",
    name: "Department",
    type: "autocomplete",
    icon: <EnergySavingsLeaf fontSize="small" />,
  },
  {
    key: "shift_name",
    name: "Shift Name",
    type: "string",
    icon: <AirlineSeatIndividualSuite fontSize="small" />,
  },
  {
    key: "shift_start_time",
    name: "Shift Start Time",
    type: "time",
    icon: <QueryBuilder fontSize="small" />,
  },
  {
    key: "shift_max_start_time",
    name: "Shift Max Start Time",
    type: "time",
    icon: <Forward5 fontSize="small" />,
  },
  {
    key: "shift_end_time",
    name: "Shift End Time",
    type: "time",
    icon: <Alarm fontSize="small" />,
  },
  {
    key: "shift_max_end_time",
    name: "Shift Max End Time",
    type: "time",
    icon: <Forward10 fontSize="small" />,
  },
  {
    key: "check_in_time",
    name: "CheckIn Time",
    type: "time",
    icon: <Timelapse fontSize="small" />,
  },
  {
    key: "check_out_time",
    name: "CheckOut Time",
    type: "time",
    icon: <SettingsBackupRestore fontSize="small" />,
  },
  {
    key: "actual_duration",
    name: "Late Arrival Duration",
    type: "time",
    icon: <LockClock fontSize="small" />,
  },
];

export const attendanceAnomilesHeader = [
  {
    key: "username",
    name: "Employee Name",
    type: "string",
    icon: <AcUnit fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee Id",
    type: "string",
    icon: <AccessibilityNew fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <AccessTime fontSize="small" />,
  },

  {
    key: "shift_name",
    name: "Shift Name",
    type: "string",
    icon: <EnergySavingsLeaf fontSize="small" />,
  },
  {
    key: "shift_start_time",
    name: "Shift Start Time",
    type: "time",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "shift_end_time",
    name: "Shift End Time",
    type: "time",
    icon: <Schedule fontSize="small" />,
  },
  {
    key: "check_in_time",
    name: "Check In",
    type: "time",
    icon: <Timelapse fontSize="small" />,
  },
  {
    key: "check_out_time",
    name: "Check Out",
    type: "time",
    icon: <QueryBuilder fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <MilitaryTech fontSize="small" />,
  },
  {
    key: "late_hours",
    name: "Late Hours",
    type: "time",
    icon: <WorkspacesOutlined fontSize="small" />,
  },
];

export const dailyReportHeader = [
  {
    key: "user_name",
    name: "Employee Name",
    type: "string",
    icon: <AcUnit fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee Id",
    type: "string",
    icon: <AccessibilityNew fontSize="small" />,
  },

  {
    key: "department_name",
    name: "Department Name",
    type: "autocomplete",
    icon: <TripOrigin fontSize="small" />,
  },
  {
    key: "shift_name",
    name: "Shift Name",
    type: "string",
    icon: <EnergySavingsLeaf fontSize="small" />,
  },
  {
    key: "check_in_time_formatted",
    name: "In",
    type: "time",
    icon: <AirlineSeatIndividualSuite fontSize="small" />,
  },
  {
    key: "check_out_time_formatted",
    name: "Out",
    type: "time",
    icon: <NoAccounts fontSize="small" />,
  },
  {
    key: "total_break_time",
    name: "Break Hr",
    type: "time",
    icon: <PermIdentity fontSize="small" />,
  },
  {
    key: "total_work_time",
    name: "Work Hr",
    type: "time",
    icon: <Rule fontSize="small" />,
  },
  {
    key: "total_over_time",
    name: "OT Hr",
    type: "time",
    icon: <Logout fontSize="small" />,
  },
  {
    key: "late_coming_minutes",
    name: "Late Coming Hr",
    type: "time",
    icon: <AssignmentLate fontSize="small" />,
  },
  {
    key: "early_leaving_minutes",
    name: "Early Leaving",
    type: "time",
    icon: <HourglassBottom fontSize="small" />,
  },
  {
    key: "location_name",
    name: "Location",
    type: "string",
    icon: <LocationOn fontSize="small" />,
  },
  {
    key: "type",
    name: "Status",
    type: "autocomplete",
    icon: <MilitaryTech fontSize="small" />,
  },
  {
    key: "modified_by",
    name: "Modified by",
    type: "time",
    icon: <BlurOn fontSize="small" />,
  },
];

export const leaveReportKeyAndHeader = [
  {
    key: "employee_id",
    name: "Employee Id",
    type: "string",
    icon: <AcUnit fontSize="small" />,
  },
  {
    key: "username",
    name: "Employee Name",
    type: "string",
    icon: <AccessibilityNew fontSize="small" />,
  },
  {
    key: "department_name",
    name: "Department",
    type: "autocomplete",
    icon: <TripOrigin fontSize="small" />,
  },
  {
    key: "paid_leave_count",
    name: "Paid Leave",
    type: "number",
    icon: <EnergySavingsLeaf fontSize="small" />,
  },
  {
    key: "unpaid_leave_count",
    name: "Unpaid Leave",
    type: "number",
    icon: <AirlineSeatIndividualSuite fontSize="small" />,
  },
  {
    key: "absent_count",
    name: "Absent",
    type: "number",
    icon: <NoAccounts fontSize="small" />,
  },
  {
    key: "permission_count",
    name: "Permission",
    type: "number",
    icon: <PermIdentity fontSize="small" />,
  },
  {
    key: "missing_count",
    name: "Missing",
    type: "number",
    icon: <Rule fontSize="small" />,
  },
  {
    key: "late_early_count",
    name: "Late / Early",
    type: "number",
    icon: <Logout fontSize="small" />,
  },
];

export const PlannedPresentReportHeader = [
  {
    key: "department_name",
    name: "Department",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    key: "over_all_male_user_count",
    name: "Male",
    type: "number",
    icon: <Boy fontSize="small" />,
  },
  {
    key: "over_all_female_user_count",
    name: "Female",
    type: "number",
    icon: <Girl fontSize="small" />,
  },
  {
    key: "over_all_total",
    name: "Total",
    type: "number",
    icon: <Functions fontSize="small" />,
  },
];

export const DeviceStatusReportHeader = [
  {
    key: "company_name",
    name: "Company Name",
    type: "string",
    icon: <Business fontSize="small" />,
  },
  {
    key: "device_name",
    name: "Device Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "location",
    name: "Location",
    type: "autocomplete",
    icon: <LocationOn fontSize="small" />,
  },
  {
    key: "direction_type",
    name: "Direction Type",
    type: "autocomplete",
    icon: <SwapHorizIcon fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },
  {
    key: "last_status_changed_local",
    name: "Status From",
    type: "string",
    icon: <QueryBuilder fontSize="small" />,
  },
  {
    key: "duration",
    name: "Status To",
    type: "string",
    icon: <QueryBuilder fontSize="small" />,
  },
  {
    key: "duration_hours",
    name: "Elapsed Time",
    type: "string",
    icon: <QueryBuilder fontSize="small" />,
  },
];

export const WrkdHrsReportHeader1 = [
  {
    key: "employee_id",
    name: "Employee Id",
    type: "string",
    icon: <Groups fontSize="small" />,
  },
  {
    key: "user_name",
    name: "Employee Name",
    type: "string",
    icon: <Boy fontSize="small" />,
  },
  {
    key: "department_name",
    name: "Department",
    type: "autocomplete",
    icon: <People fontSize="small" />,
  },
];

export const WrkdHrsReportHeader2 = [
  {
    key: "absent_count",
    name: "ABS days",
    type: "number",
    icon: <PersonRemove fontSize="small" />,
  },
  {
    key: "total_duty_hours",
    name: "Duty Hours",
    type: "time",
    icon: <Functions fontSize="small" />,
  },
  {
    key: "ot_hours",
    name: "OT Hours",
    type: "time",
    icon: <WorkHistory fontSize="small" />,
  },
  {
    key: "total_break_hours",
    name: "Break Hours",
    type: "time",
    icon: <HourglassBottom fontSize="small" />,
  },
  {
    key: "total_duty_ot_break_hours",
    name: "Total Hours",
    subHeader: "( Duty + OT )",
    type: "time",
    icon: <JoinFull fontSize="small" />,
  },
];

export const overtimeReportHeder = [
  {
    key: "user_name",
    name: "Employee Name",
    type: "string",
    icon: <AcUnit fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee Id",
    type: "string",
    icon: <AccessibilityNew fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
  },
  {
    key: "shift",
    name: "Shift Name",
    type: "string",
    icon: <FilterTiltShift fontSize="small" />,
  },
  {
    key: "department_name",
    name: "Department",
    type: "autocomplete",
    icon: <TripOrigin fontSize="small" />,
  },
  {
    key: "overtime_start_formated",
    name: "OT Start",
    type: "time",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "overtime_end_formated",
    name: "OT End",
    type: "time",
    icon: <Timelapse fontSize="small" />,
  },
  {
    key: "overtime_break_duration",
    name: "Break Duration",
    type: "time",
    icon: <Watch fontSize="small" />,
  },
  {
    key: "overtime_duration",
    name: "Duration",
    type: "time",
    icon: <Alarm fontSize="small" />,
  },
  {
    key: "final_approved_duration",
    name: "Approved Duration",
    type: "time",
    icon: <ScheduleSend fontSize="small" />,
  },
];

// ot updated design

export const OTPreApprovalHeader = [
  {
    key: "expand",
    name: "",
  },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "ot_date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "ot_date",
      toField: "ot_date",
    },
  },
  {
    key: "ot_duration",
    name: "Duration",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "ot_consideration",
    name: "Applicable Timing",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },
];

export const OTPostApprovalHeader = [
  {
    key: "expand",
    name: "",
  },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "worked_hours",
    name: "Worked Hrs",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "basis",
    name: "Basis",
    type: "autocomplete",
    icon: <Foundation fontSize="small" />,
  },
  {
    key: "worked_qty",
    name: "Worked Qty",
    type: "string",
    icon: <WorkspacesOutlined fontSize="small" />,
  },
  {
    key: "approved_qty",
    name: "Approved Qty",
    type: "string",
    icon: <CheckCircleOutline fontSize="small" />,
  },
  {
    key: "payout_policy",
    name: "Payout Policy",
    type: "autocomplete",
    icon: <Policy fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

export const otTimingOptions = [
  {
    id: "Only Before",
    label: "Before shift",
    description:
      "Allow employees to log overtime for hours worked before their scheduled shift begins.",
  },
  {
    id: "Only After",
    label: "After shift",
    description:
      "Enable overtime entry for additional hours worked beyond the regular shift end time.",
  },
  {
    id: "Before and After",
    label: "Before and After Shift",
    description:
      "Permit overtime logging for both early start and extended work hours outside the regular shift schedule.",
  },
];

export const SpecialAttendanceHeader = [
  {
    key: "expand",
    name: "",
  },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <People fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "attendance_type",
    name: "Type",
    type: "autocomplete",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "duration",
    name: "Duration",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

export const WorkAdjustmentAttendanceType = [
  {
    label: "On Duty",
  },
  {
    label: "Permission",
  },
  {
    label: "Comp off",
  },
  {
    label: "Break",
  },
  {
    label: "Cancel Break",
  },
];

export const dayOffPreApproval = [
  {
    key: "expand",
    name: "",
  },
  {
    key: "employee_name",
    name: "Name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    key: "employee_id",
    name: "Employee ID",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    key: "date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "day_type",
    name: "Day Type",
    type: "string",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

export const attendanceDepartmentFilter = [
  {
    key: "department_name",
    name: "Department",
    type: "string",
    icon: <WorkspacesIcon fontSize="small" />,
  },
  {
    key: "staff_planned_count",
    name: "Planned",
    type: "number",
    icon: <EventNoteIcon fontSize="small" />,
  },
  {
    key: "staff_present_count",
    name: "Present",
    type: "number",
    icon: <CheckCircleOutlineIcon fontSize="small" />,
  },
  {
    key: "staff_overtime_count",
    name: "Overtime",
    type: "number",
    icon: <AccessTimeIcon fontSize="small" />,
  },
  {
    key: "staff_missing_count",
    name: "Missing",
    type: "number",
    icon: <PersonOffOutlinedIcon fontSize="small" />,
  },
  {
    key: "staff_absent_count",
    name: "Absent",
    type: "number",
    icon: <CancelOutlinedIcon fontSize="small" />,
  },
  {
    key: "staff_late_early",
    name: "Late / Early",
    type: "number",
    icon: <SwapHorizIcon fontSize="small" />,
  },
];

export const attendanceEmployeeFilter = [
  {
    name: "Employee Name",
    key: "user_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "User Code",
    key: "user_code",
    type: "string",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Department",
    key: "department_name",
    type: "autocomplete",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Check In Time",
    key: "check_in_time_formatted",
    type: "time",
    icon: <LocationOn fontSize="small" />,
  },
  {
    name: "Check Out Time",
    key: "check_out_time_formatted",
    type: "time",
    icon: <LocationOn fontSize="small" />,
  },
  {
    name: "Working hours",
    key: "total_work_time",
    type: "time",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "Status",
    key: "type",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

export const LeaveStatusTag = {
  Present: "LP1", // Leave Present (any punch)
  "On Duty": "LOD",
  Permission: "LPR",
  "Week Off": "W", // usually unchanged
  Leave: "L", // base leave
  Absent: "LA",
  Active: "LP",
  Break: "LBR",
  Out: "LO",
  Overtime: "LOT",
  Missing: "LM",
  Late: "LL1",
  Early: "LE",
  Total: "",
  Planned: "P2",
  "Approved OT": "LAOT",
  "Pending OT": "LPOT",
  "Rejected OT": "LROT",
  "Ineligible OT": "LIOT",
};

export const OverAllStatusTag = {
  Present: "P1",
  "On Duty": "OD",
  Permission: "PR",
  "Week Off": "W",
  Leave: "L",
  Absent: "A",
  Active: "P",
  Break: "BR",
  Out: "O",
  Overtime: "OT",
  Missing: "M",
  Late: "L1",
  Early: "E",
  Total: "",
  Planned: "P2",
  "Approved OT": "AOT",
  "Pending OT": "POT",
  "Rejected OT": "ROT",
  "Ineligible OT": "IOT",
};

export const WeekoffStatusTag = {
  Present: "WP1",
  "On Duty": "WOD",
  Permission: "WPR",
  "Week Off": "W",
  Leave: "L",
  Absent: "WA",
  Active: "WP",
  Break: "WBR",
  Out: "WO",
  Overtime: "WOT",
  Missing: "WM",
  Late: "WL1",
  Early: "WE",
  Total: "",
  Planned: "P2",
  "Approved OT": "WAOT",
  "Pending OT": "WPOT",
  "Rejected OT": "WROT",
  "Ineligible OT": "WIOT",
};

export const PlannedStatusTag = {
  Present: "PP1",
  "On Duty": "POD",
  Permission: "PPR",
  "Week Off": "W",
  Leave: "L",
  Absent: "PA",
  Active: "PP",
  Break: "PBR",
  Out: "PO",
  Overtime: "PPOT",
  Missing: "PM",
  Late: "PL1",
  Early: "PE",
  Total: "",
  Planned: "P2",
  "Approved OT": "PAOT",
  "Pending OT": "PPPOT",
  "Rejected OT": "PROT",
  "Ineligible OT": "WIOT",
};

// shiftCategoryHeader;

export const departmentView = [
  { name: "", key: "" },
  { name: "Name", key: "department_name" },
  { name: "Manager", key: "manager_name" },
  { name: "Total", key: "overall_count" },
  {
    name: "Total",
    children: [
      { name: "Planned", key: "planned_count" },
      { name: "Leave", key: "leave_count" },
      { name: "Week Off", key: "weekoff_count" },
      { name: "On Duty", key: "onduty_count" },
    ],
  },

  {
    name: "Planned",
    children: [
      { name: "Present", key: "present_count" },
      { name: "Absent", key: "absent_count" },
      { name: "Permission", key: "permission_count" },
    ],
  },

  {
    name: "Present",
    children: [
      { name: "Active", key: "active_count" },
      { name: "Break", key: "break_count" },
      { name: "Out", key: "out_count" },
      { name: "Late", key: "late_count" },
      { name: "Early", key: "early_exit_count" },
      { name: "OT", key: "overtime_count" },
    ],
  },
];

export const departmentViewFlat = [
  {
    name: "Name",
    key: "department_name",
    type: "string",
    icon: <Business fontSize="small" />,
  },
  {
    name: "Manager",
    key: "manager_name",
    type: "string",
    icon: <Person fontSize="small" />,
  },
  {
    name: "Total",
    key: "overall_count",
    type: "number",
    icon: <Groups fontSize="small" />,
  },

  // Total Section
  {
    name: "Planned",
    key: "planned_count",
    type: "number",
    icon: <EventAvailable fontSize="small" />,
  },
  {
    name: "Leave",
    key: "leave_count",
    type: "number",
    icon: <BeachAccess fontSize="small" />,
  },
  {
    name: "Week Off",
    key: "weekoff_count",
    type: "number",
    icon: <Weekend fontSize="small" />,
  },
  {
    name: "On Duty",
    key: "onduty_count",
    type: "number",
    icon: <Work fontSize="small" />,
  },

  // Planned Section
  {
    name: "Present",
    key: "present_count",
    type: "number",
    icon: <CheckCircle fontSize="small" />,
  },
  {
    name: "Absent",
    key: "absent_count",
    type: "number",
    icon: <Cancel fontSize="small" />,
  },
  {
    name: "Missing",
    key: "missing_count",
    type: "number",
    icon: <ErrorOutline fontSize="small" />,
  },
  {
    name: "Permission",
    key: "permission_count",
    type: "number",
    icon: <LockOpen fontSize="small" />,
  },

  // Present Section
  {
    name: "Active",
    key: "active_count",
    type: "number",
    icon: <DirectionsRun fontSize="small" />,
  },
  {
    name: "Break",
    key: "break_count",
    type: "number",
    icon: <FreeBreakfast fontSize="small" />,
  },
  {
    name: "Out",
    key: "out_count",
    type: "number",
    icon: <ExitToApp fontSize="small" />,
  },
  {
    name: "Late",
    key: "late_count",
    type: "number",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "Early",
    key: "early_exit_count",
    type: "number",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "OT",
    key: "overtime_count",
    type: "number",
    icon: <TrendingUp fontSize="small" />,
  },
];

export const shiftViewHeader = [
  { name: "", key: "" },
  { name: "Name", key: "shift_name" },
  { name: "Total", key: "overall_count" },

  {
    name: "Total",
    children: [
      { name: "Planned", key: "planned_count" },
      { name: "Leave", key: "leave_count" },
      { name: "Week Off", key: "weekoff_count" },
      { name: "On Duty", key: "onduty_count" },
    ],
  },

  {
    name: "Planned",
    children: [
      { name: "Present", key: "present_count" },
      { name: "Absent", key: "absent_count" },
      { name: "Permission", key: "permission_count" },
    ],
  },

  {
    name: "Present",
    children: [
      { name: "Active", key: "active_count" },
      { name: "Break", key: "break_count" },
      { name: "Out", key: "out_count" },
      { name: "Late", key: "late_count" },
      { name: "Early", key: "early_exit_count" },
      { name: "OT", key: "overtime_count" },
    ],
  },
];

export const shiftViewFlat = [
  {
    name: "Name",
    key: "shift_name",
    type: "string",
    icon: <Business fontSize="small" />,
  },
  {
    name: "Total",
    key: "overall_count",
    type: "number",
    icon: <Groups fontSize="small" />,
  },

  // Total Section
  {
    name: "Planned",
    key: "planned_count",
    type: "number",
    icon: <EventAvailable fontSize="small" />,
  },
  {
    name: "Leave",
    key: "leave_count",
    type: "number",
    icon: <BeachAccess fontSize="small" />,
  },
  {
    name: "Week Off",
    key: "weekoff_count",
    type: "number",
    icon: <Weekend fontSize="small" />,
  },
  {
    name: "On Duty",
    key: "onduty_count",
    type: "number",
    icon: <Work fontSize="small" />,
  },

  // Planned Section
  {
    name: "Present",
    key: "present_count",
    type: "number",
    icon: <CheckCircle fontSize="small" />,
  },
  {
    name: "Absent",
    key: "absent_count",
    type: "number",
    icon: <Cancel fontSize="small" />,
  },
  {
    name: "Missing",
    key: "missing_count",
    type: "number",
    icon: <ErrorOutline fontSize="small" />,
  },
  {
    name: "Permission",
    key: "permission_count",
    type: "number",
    icon: <LockOpen fontSize="small" />,
  },

  // Present Section
  {
    name: "Active",
    key: "active_count",
    type: "number",
    icon: <DirectionsRun fontSize="small" />,
  },
  {
    name: "Break",
    key: "break_count",
    type: "number",
    icon: <FreeBreakfast fontSize="small" />,
  },
  {
    name: "Out",
    key: "out_count",
    type: "number",
    icon: <ExitToApp fontSize="small" />,
  },
  {
    name: "Late",
    key: "late_count",
    type: "number",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "Early",
    key: "early_exit_count",
    type: "number",
    icon: <AccessTime fontSize="small" />,
  },
  {
    name: "OT",
    key: "overtime_count",
    type: "number",
    icon: <TrendingUp fontSize="small" />,
  },
];

// Employee Attendance Report (EsslReport) — per-employee stat fields shown in
// each employee card's summary strip. Identity (Name/Employee Id/Department)
// isn't part of this list since it's the card's fixed heading, not a
// togglable field, same distinction TimeCardReport draws between its always-
// present expand chevron and its saved-view-controlled columns.
export const EmployeeAttendanceSummaryHeader = [
  {
    key: "Present_Days",
    name: "Present Days",
    type: "number",
    icon: <CheckCircle fontSize="small" />,
  },
  {
    key: "Absent_Days",
    name: "Absent Days",
    type: "number",
    icon: <Cancel fontSize="small" />,
  },
  {
    key: "Leaves_Taken",
    name: "Leaves Taken",
    type: "number",
    icon: <BeachAccess fontSize="small" />,
  },
  {
    key: "Week_Off_Days",
    name: "Week Off Days",
    type: "number",
    icon: <Weekend fontSize="small" />,
  },
  {
    key: "Holidays",
    name: "Holidays",
    type: "number",
    icon: <EventAvailable fontSize="small" />,
  },
  {
    key: "Total_Working_Hrs",
    name: "Total Working Hrs",
    type: "time",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "Avg_Working_Hrs",
    name: "Avg Working Hrs",
    type: "time",
    icon: <Schedule fontSize="small" />,
  },
  {
    key: "OT_Hrs",
    name: "OT Hrs",
    type: "time",
    icon: <WorkHistory fontSize="small" />,
  },
  {
    key: "Late_By_Hrs",
    name: "Late By Hrs",
    type: "time",
    icon: <Alarm fontSize="small" />,
  },
  {
    key: "Early_By_Hrs",
    name: "Early By Hrs",
    type: "time",
    icon: <Forward5 fontSize="small" />,
  },
  {
    key: "Early_Going_By_Days",
    name: "Early Going Days",
    type: "number",
    icon: <ExitToApp fontSize="small" />,
  },
];

// Employee Attendance Report — per-day attendance rows shown in each
// employee's day-by-day matrix (and, transposed to one row per day, in the
// grouped Excel/PDF/CSV export via useExcelDownload's downloadGroupedExcel).
// Keys line up 1:1 with the essl-report API's daily_records fields.
export const EmployeeAttendanceDetailHeader = [
  {
    key: "Attendance_Status",
    name: "Status",
    type: "autocomplete",
    icon: <CheckCircleOutline fontSize="small" />,
  },
  {
    key: "Shift_Code",
    name: "Shift",
    type: "string",
    icon: <Schedule fontSize="small" />,
  },
  {
    key: "Check_In",
    name: "Check In",
    type: "time",
    icon: <AccessTimeIcon fontSize="small" />,
  },
  {
    key: "Check_Out",
    name: "Check Out",
    type: "time",
    icon: <Watch fontSize="small" />,
  },
  {
    key: "Break_Duration",
    name: "Break Duration",
    type: "time",
    icon: <HourglassBottom fontSize="small" />,
  },
  {
    key: "Total_Worked_Hrs",
    name: "Total Worked Hrs",
    type: "time",
    icon: <Functions fontSize="small" />,
  },
  {
    key: "Late_By",
    name: "Late By",
    type: "time",
    icon: <Alarm fontSize="small" />,
  },
  {
    key: "Early_By",
    name: "Early By",
    type: "time",
    icon: <Forward5 fontSize="small" />,
  },
  {
    key: "Net_Shift_Hrs",
    name: "Net Shift Hrs",
    type: "time",
    icon: <JoinFull fontSize="small" />,
  },
  {
    key: "OverTime_Hrs",
    name: "OverTime Hrs",
    type: "time",
    icon: <WorkHistory fontSize="small" />,
  },
];
